// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.button-with-status-container {
  display: flex;
}

.status-on-button {
  position: relative;
  bottom: 10px;
  right: 20px;
}

.action-button-reg {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.action-button-reg:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-reg:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-80 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 80px;
  margin: 0 10px;
}
.action-button-80:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-80:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-100:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-150 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 150px;
  margin: 0 10px;
}
.action-button-150:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-150:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-200 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 200px;
  margin: 0 10px;
}
.action-button-200:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-200:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-delete {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #CB321A;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 250px;
  margin: 0 10px;
}
.action-button-delete:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-delete:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-delete-100 {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #CB321A;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  width: 100px;
  margin: 0 10px;
}
.action-button-delete-100:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-delete-100:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-small-trashCan {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  height: 20px;
  transition: 0.1s ease;
  width: 40px;
  margin: 0 10px;
}
.action-button-small-trashCan:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-small-trashCan:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-cancel {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  border: none;
  background: #A7A9AC;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
}
.action-button-cancel:hover {
  transform: scale(1.015);
  background: #808080;
}
.action-button-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-button-hide-dropdown {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  border: none;
  background: #0669B3;
  background: #A7A9AC;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  margin: 0 10px;
  width: 100%;
}
.action-button-hide-dropdown:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-hide-dropdown:disabled {
  opacity: 0.51;
  cursor: not-allowed;
}

.action-button-birthdate-reset {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  height: 30px;
  transition: 0.1s ease;
  padding: 0px 20px;
  width: 200px;
}
.action-button-birthdate-reset:hover {
  transform: scale(1.015);
  background: #1786DB;
}
.action-button-birthdate-reset:disabled {
  opacity: 0.51;
  cursor: not-allowed;
}

.action-button-reason {
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  background: #0669B3;
  color: white;
  font-size: 0.9rem;
  height: 30px;
  padding: 0px 20px;
  margin: 0 10px;
  transition: 0.1s ease;
  white-space: nowrap;
}

.select-button-icon {
  display: flex;
  align-items: center;
}

@media only screen and (max-width: 1080px) {
  .action-button-reason {
    font-size: 0.7rem;
    padding: 0px 8px;
  }
}`, "",{"version":3,"sources":["data:;charset=utf-8,*,%0A*::before,%0A*::after%20%7B%0A%20%20%20%20box-sizing:%20border-box;%0A%7D%0A/%20Guardian%20Dashboard%20colors%0A$lt-blue:%20%237DB7CC;%0A$dk-blue:%20%2319608f;%0A%0A$error:%20%23CE3525;%0A$error-dk:%20%23aa3333;%0A$error-hover:%20%23cf4635;%0A$hover-white:%20%23E0E0E0;%0A$light-background:%20%23EFEFEF;%0A%0A$information:%20%2300AEEF;%0A$information-hover:%20%2302BFFF;%0A$text:%20%23414042;%0A$white:%20%23EDEDED;%0A$shadow:%20%23525151;%0A$red:%20%23CB321A;%0A$green:%20%234a8319;%0A%0A$important:%20%23FEBF31;%0A$greyLight:%20%23F8F8F8;%0A$grey0:%20%23EDf0F1;%0A$grey1:%20%23D1D3D4;%0A$grey2:%20%23A7A9AC;%0A$grey3:%20%23808080;%0A$grey3a:%20%23707070;%0A$grey4:%20%23636161;%0A$grey4a:%20%23444343;%0A$pale-blue:%20%23C0DEF0;%0A$pearl-blue:%20%230669B3;%0A$pearl-blue-hover:%20%231786DB;%0A$lt-pearl-blue:%20%2363AEDE;%0A$lt-pearl-blue-hover:%20%234589B3;%0A$icon-blue:%20%234DD9FF;%0A","webpack://./src/styles/ActionButton.scss","data:;charset=utf-8,@use%20%22./Colors.scss%22;%0A%0A@mixin%20borderRadius($radius:%205px)%20%7B%0A%20%20%20%20border-radius:%20$radius;%0A%7D%0A%0A@mixin%20dialogueBold()%20%7B%0A%20%20%20%20font-weight:%20600;%0A%20%20%20%20font-size:%20.9em;%0A%7D%0A%0A@mixin%20input()%20%7B%0A%20%20%20%20border-radius:%205px;%0A%20%20%20%20font-weight:%20400;%0A%20%20%20%20width:%20100%25;%0A%7D%0A%0A@mixin%20infoRounded($radius)%20%7B%0A%20%20%20%20background:%20Colors.$information;%0A%20%20%20%20border-bottom-left-radius:%20$radius;%0A%20%20%20%20border-bottom-right-radius:%20$radius;%0A%7D%0A%0A@mixin%20shadow()%20%7B%0A%20%20%20%20box-shadow:%200.1rem%200.15rem%200.3rem%200%20Colors.$shadow;%0A%7D%0A%0A@mixin%20shadowCustom($hor:%201px,%20$vert:%201px,%20$blur:%202px,%20$color:%20Colors.$shadow)%20%7B%0A%20%20%20%20box-shadow:%20$hor%20$vert%20$blur%20$color;%0A%7D%0A%0A@mixin%20shadowBottom()%20%7B%0A%20%20%20%20box-shadow:%200%200.1rem%200.15rem%200%20Colors.$shadow;%0A%7D%0A%0A@mixin%20standardInputContainer()%20%7B%0A%20%20%20%20font-weight:%20500;%0A%20%20%20%20font-size:%20.9rem;%0A%20%20%20%20margin:%2010px%200;%0A%7D%0A%0A@mixin%20standardInput()%20%7B%0A%20%20%20%20@include%20borderRadius(5px);%0A%20%20%20%20border:%20none;%0A%20%20%20%20border:%201px%20solid%20Colors.$grey3;%0A%20%20%20%20padding:%205px;%0A%7D%0A"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AADA;EACE,aAAA;AAIF;;AADA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAIF;;AADA;ECVI,kBDWiC;ECUjC,2CAAA;EDRF,eAAA;EACA,YAAA;EACA,mBDeW;ECdX,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAIF;AAFE;EACE,uBAAA;EACA,mBDOe;ACHnB;AADE;EACE,YAAA;EACA,mBAAA;AAGJ;;AACA;ECjCI,kBDkCiC;ECbjC,2CAAA;EDeF,eAAA;EACA,YAAA;EACA,mBDRW;ECSX,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAEF;AAAE;EACE,uBAAA;EACA,mBDhBe;ACkBnB;AACE;EACE,YAAA;EACA,mBAAA;AACJ;;AAGA;ECxDI,kBDyDiC;ECpCjC,2CAAA;EDsCF,eAAA;EACA,YAAA;EACA,mBD/BW;ECgCX,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAAF;AAEE;EACE,uBAAA;EACA,mBDvCe;ACuCnB;AAGE;EACE,YAAA;EACA,mBAAA;AADJ;;AAKA;EC/EI,kBDgFiC;EC3DjC,2CAAA;ED6DF,eAAA;EACA,YAAA;EACA,mBDtDW;ECuDX,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAFF;AAIE;EACE,uBAAA;EACA,mBD9De;AC4DnB;AAKE;EACE,YAAA;EACA,mBAAA;AAHJ;;AAOA;ECtGI,kBDuGiC;EClFjC,2CAAA;EDoFF,eAAA;EACA,YAAA;EACA,mBD7EW;EC8EX,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AAJF;AAME;EACE,uBAAA;EACA,mBDrFe;ACiFnB;AAOE;EACE,YAAA;EACA,mBAAA;AALJ;;AASA;EC7HI,kBD8HiC;ECzGjC,2CAAA;ED2GF,eAAA;EACA,YAAA;EACA,mBDjHI;ECkHJ,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AANF;AAQE;EACE,uBAAA;EACA,mBD5Ge;ACsGnB;AASE;EACE,YAAA;EACA,mBAAA;AAPJ;;AAWA;ECpJI,kBDqJiC;EChIjC,2CAAA;EDkIF,eAAA;EACA,YAAA;EACA,mBDxII;ECyIJ,YAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;AARF;AAUE;EACE,uBAAA;EACA,mBDnIe;AC2HnB;AAWE;EACE,YAAA;EACA,mBAAA;AATJ;;AAaA;EC3KI,kBD4KiC;ECvJjC,2CAAA;EDyJF,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBDrJW;ECsJX,YAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AAVF;AAYE;EACE,uBAAA;EACA,mBD7Je;ACmJnB;AAaE;EACE,YAAA;EACA,mBAAA;AAXJ;;AAeA;ECrMI,kBDsMiC;ECjLjC,2CAAA;EDmLF,eAAA;EACA,YAAA;EACA,mBDlLM;ECmLN,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AAZF;AAcE;EACE,uBAAA;EACA,mBDzLI;AC6KR;AAeE;EACE,YAAA;EACA,mBAAA;AAbJ;;AAiBA;EC3NI,kBD4NiC;ECvMjC,2CAAA;EDyMF,eAAA;EACA,aAAA;EACA,uBAAA;EAEA,YAAA;EACA,mBDrMW;ECsMX,mBD5MM;EC6MN,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAfF;AAiBE;EACE,uBAAA;EACA,mBD/Me;ACgMnB;AAkBE;EACE,aAAA;EACA,mBAAA;AAhBJ;;AAoBA;ECvPI,kBDwPiC;ECnOjC,2CAAA;EDqOF,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,YAAA;EACA,mBDlOW;ECmOX,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,YAAA;AAlBF;AAoBE;EACE,uBAAA;EACA,mBD1Oe;ACwNnB;AAqBE;EACE,aAAA;EACA,mBAAA;AAnBJ;;AAuBA;EClRI,kBDmRiC;EACnC,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBD1PW;EC2PX,YAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,mBAAA;AApBF;;AAuBA;EACE;IACE,iBAAA;IACA,gBAAA;EApBF;AACF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
